import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import PurchaseOrderService from "../../services/purchaseorder.service";
import AdminService from "../../services/admin.service";
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';

const AdminClosedPODetailsDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [po, setPO] = useState();
    const [showJson, setShowJson] = useState(false);
    const [response, setResponse] = useState();

    let poId = location.state.poId;
    console.log("POID", poId);

    useEffect(() => {
        console.log("LOADING CLOSED POS");
        async function fetchData() {
            var response = await PurchaseOrderService.getClosedPurchaseOrder(poId);
            setPO(response.data);
        }
        fetchData();
    }, []);


    const downloadPO = async (id) => {
        console.log("Downloading PO");
        var status = await AdminService.downloadPO(id);
    }

    const generatePO = async (id) => {
        console.log("Downloading PO");
        var status = await PurchaseOrderService.generateXLS(id);
    }

    const submitToSanmar = async (id) => {
        var status = await PurchaseOrderService.submitToSanmar(id);
        setPO(status.po);
    }

    const submitPreflightToSanmar = async (id) => {
        var status = await PurchaseOrderService.submitPreflightToSanmar(id);
        console.log("PRELFIGHT RESPONSE", status);
        setPO(status.po);
    }

    return (
        <div className="container">
            {po && (
                <div>
                    <h1>Purchase Order # {po.id}</h1>
                    <Container className="user-data">
                        <Row>
                            <Col className="title" xs={3}>
                                Generate PO XLS
                            </Col>
                            <Col className="value">
                                <Button onClick={() => generatePO(po.id)}>Generate PO XLS</Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="title" xs={3}>
                                Download PO XLS
                            </Col>
                            <Col className="value">
                                <Button onClick={() => downloadPO(po.id)}>Download</Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="title" xs={3}>
                                Created On:
                            </Col>
                            <Col className="value">
                                {new Date(po.createdAt).toLocaleDateString('en-us', { year: "numeric", month: "short", day: "numeric" })}
                            </Col>
                        </Row>
                        <Row>
                            <Col className="title" xs={3}>
                                Finalized By:
                            </Col>
                            <Col className="value">
                                {po.finalizedBy.lastname + ", " + po.finalizedBy.firstname}
                            </Col>
                        </Row>
                        <Row>
                            <Col className="title" xs={3}>
                                Sanmar Prelfight:
                            </Col>
                            <Col className="value">
                                <Button onClick={() => submitPreflightToSanmar(po.id)}>Send Sanmar Preflight</Button><br />
                                <Container>
                                    <Row style={{border: "1px solid #cccccc", padding: 5, backgroundColor: "#CCCCCC"}}>
                                        <Col style={{textAlign: "center"}}>
                                            Last Preflight Run
                                        </Col>
                                    </Row>
                                    <Row style={{border: "1px solid #cccccc", padding: 5}}>
                                        <Col>
                                            Date
                                        </Col>
                                        <Col>
                                            {po.preflightDate}
                                        </Col>
                                    </Row>
                                    <Row style={{border: "1px solid #cccccc", padding: 5}}>
                                        <Col>
                                            Status
                                        </Col>
                                        <Col>
                                            {po.preflightStatus}
                                        </Col>
                                    </Row>
                                    <Row style={{border: "1px solid #cccccc", padding: 5}}>
                                        <Col>
                                            Response
                                        </Col>
                                        <Col>
                                            <Button onClick={() => { setResponse(po.preflightResponse); setShowJson(true); }}>Show Full Response</Button>
                                        </Col>
                                    </Row>
                                </Container>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="title" xs={3}>
                                Sent To Sanmar:
                            </Col>
                            <Col className="value">
                            <Button variant="danger" onClick={() => submitToSanmar(po.id)}>Send To Sanmar</Button>
                            <Container>
                                    <Row style={{border: "1px solid #cccccc", padding: 5, backgroundColor: "#CCCCCC"}}>
                                        <Col style={{textAlign: "center"}}>
                                            Last Sanmar Run
                                        </Col>
                                    </Row>
                                    <Row style={{border: "1px solid #cccccc", padding: 5}}>
                                        <Col>
                                            Date
                                        </Col>
                                        <Col>
                                            {po.sentToSanmarDate}
                                        </Col>
                                    </Row>
                                    <Row style={{border: "1px solid #cccccc", padding: 5}}>
                                        <Col>
                                            Status
                                        </Col>
                                        <Col>
                                            {po.sanmarStatus}
                                        </Col>
                                    </Row>
                                    <Row style={{border: "1px solid #cccccc", padding: 5}}>
                                        <Col>
                                            Response
                                        </Col>
                                        <Col>
                                            <Button onClick={() => { setResponse(po.sanmarResponse); setShowJson(true); }}>Show Full Response</Button>
                                        </Col>
                                    </Row>
                                </Container>
                            </Col>
                        </Row>
                    </Container>
                    {showJson && (
                        <Modal show={showJson} onHide={() => setShowJson(false)}>
                            <Modal.Header closeButton>
                                <Modal.Title>Sanmar Response</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Container className="user-data">
                                    {response &&
                                    <pre>{JSON.stringify(JSON.parse(response), null, 2)}</pre>
                                    }
                                </Container>
                            </Modal.Body>

                        </Modal>
                    )}
                </div>
            )}
        </div>

    );
};
export default AdminClosedPODetailsDetails;